import React, { useState, useEffect } from 'react';
import { string, shape, bool } from 'prop-types';
import { Label, Input } from '@americanexpress/dls-react';
import { useSelector } from 'react-redux';
import { getProfileUser } from '../utils';
import { getFuidUserId } from '../selectors';

const UserIdInput = ({
  userId,
  type,
  hideMultiPageUserId,
  hideUserId,
  inputLabel,
  userRef,
  disable,
  moduleState,
}) => {
  const fuidUserId = useSelector(getFuidUserId);
  const [value, setValue] = useState(fuidUserId || getProfileUser() || userId);

  useEffect(() => {
    const userIdValue = fuidUserId || getProfileUser() || moduleState.userId;
    setValue(userIdValue);
  }, [moduleState.userId]);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (type === 'multipage' ? !hideMultiPageUserId : !hideUserId) ? (
    <div className="form-group">
      <Label id="eliloUserID-label" htmlFor="eliloUserID">{inputLabel}</Label>
      <Input
        id="eliloUserID"
        value={value}
        onChange={handleChange}
        data-testid="userid-input"
        type="text"
        aria-labelledby="eliloUserID-label"
        ref={userRef}
        disabled={disable}
        autoComplete="username"
        reactlytics={{
          element: 'Login_UserIdInput',
        }}
      />
    </div>
  ) : '';
};

UserIdInput.propTypes = {
  userId: string,
  type: string,
  inputLabel: string,
  disable: string,
  hideMultiPageUserId: bool,
  hideUserId: bool,
  userRef: shape({}),
  moduleState: shape({}),
};

UserIdInput.defaultProps = {
  type: undefined,
};

export default UserIdInput;
